import { ApplicationConfig, isDevMode, ErrorHandler, importProvidersFrom, APP_INITIALIZER, Injector, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideStore, StoreModule } from '@ngrx/store';
import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { providePrimeNG } from 'primeng/config';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MessageService, ConfirmationService } from 'primeng/api';
import { LocationStrategy, HashLocationStrategy, registerLocaleData, DatePipe } from '@angular/common';
import { IntercepterService } from 'libs/api/src/lib/intercepter.service';
import { AlertErrorHandler } from '@fitness-force/errors';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { ApplicationInitializerFactory } from '@fitness-force/shared';
import { Store } from '@ngrx/store';
import Lara from '@primeng/themes/lara';
import { appointmentTypeReducer, authReducer, cityListReducer, claimsReducer, classTypeReducer,
  companyReducer, countryListReducer, locationReducer, roomReducer, serviceTypeReducer, staffNotificationReducer, staffReducer, stageReducer, 
  stateListReducer, StatsigReducer, TenantReducer, tenantReducer, themeReducer, 
  trialMasterReducer} from './state/app.reducer';
  import { routerReducer } from '@ngrx/router-store';
import { CompanyEffects } from './state/effect';
import { ThemeEffects } from './state/theme.effect';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import localeAr from '@angular/common/locales/ar';
import { provideAnimations } from '@angular/platform-browser/animations';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { environment } from '../environments/environment';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

registerLocaleData(localeAr);


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideStore(),
    provideEffects(),
    provideAnimations(),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
    }),
    importProvidersFrom(
      StoreModule.forRoot({
        company: companyReducer,
        claims: claimsReducer,
        tenants: tenantReducer,
        countries: countryListReducer,
        staff: staffReducer,
        router: routerReducer,
        stages: stageReducer,
        appointmentTypes: appointmentTypeReducer,
        classTypes: classTypeReducer,
        states: stateListReducer,
        cities: cityListReducer,
        serviceTypeList: serviceTypeReducer,
        rooms: roomReducer,
        location: locationReducer,
        tenant: TenantReducer,
        auth: authReducer,
        statsigReducer: StatsigReducer,
        staffPreferences: staffNotificationReducer,
        theme: themeReducer,
        trials: trialMasterReducer
      }),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    importProvidersFrom(EffectsModule.forRoot([CompanyEffects,ThemeEffects])),
    MessageService,
    ConfirmationService,
    DatePipe,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: IntercepterService, multi: true },
    { provide: ErrorHandler, useClass: AlertErrorHandler },
    {
      provide: APP_INITIALIZER,
      useFactory: ApplicationInitializerFactory,
      deps: [TranslateService, Injector, Store],
      multi: true
    },

    importProvidersFrom(
      GoogleTagManagerModule.forRoot({
      id: environment.googleGTM,
    }),
    ),
    providePrimeNG({
      ripple: true,
      inputVariant: 'outlined',
      theme: {
        preset: Lara,
        options: {
            prefix: 'p',
            darkModeSelector: 'system',
            cssLayer: false
        }
    },
      zIndex: {
        modal: 1100,
        overlay: 1000,
        menu: 1000,
        tooltip: 1100
      }
    })
  ]
}; 